// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'

const preventCallsignCascadeCheck = () => (dispatch, getState) => {
  const {
    pathDetails,
    projectSummary,
    user,
  } = getState()

  const isNewPath = pathDetails.get('pathId') === null
  const withinProjectSummary = pathDetails.get('withinProjectSummary')

  const isExternalPcnProject = (
    projectSummary.getIn(['projectType', 'projectTypeId']) === ProjectTypeIdEnum.EXTERNAL_PCN
  )

  return (
    // we simply do not need to do a callsign check for new paths.
    isNewPath ||
    // if this isn't a DB user, then there's no reason to do this check.
    // only DB user work flows are relevant to Call Sign Cascade.
    user.getIn(['permissions', 'database']) === false ||

    // if we're within project summary, then we need to make sure that
    // the user is editing an External PCN project. Engineering projects
    // do not use Callsign Cascade in their workflow.

    // NOTE - we don't check anything about !withinProjectSummary here
    // because that is for Path Database workflow and that workflow
    // explicitly does not show In Progress Engineering paths.
    withinProjectSummary && !isExternalPcnProject
  )
}

export default preventCallsignCascadeCheck
